import { createElement } from 'react';

import { Components, Theme } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

import { Icon } from '@/components/ui/Icon';
import { IconProps } from '@/components/ui/Icon';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    autoWidth: false,
    IconComponent: (props: IconProps) =>
      createElement(
        'div',
        {
          /* The way Mui Select handles the icon rotation conflicts with our desired input height and icon size,
           * making the icon cause width and height bleed on rotation when opened. To fix this, we wrap the icon
           * in a div that hides the overflow and has the same height as the input, so when the icon rotates
           * it doesn't bleed outside of the select.
           *
           * Somehow, Mui figures out automatically to still add the rotation to the icon and not the div, so we do
           * not need to overwrite anything to handle the rotation ourselves.
           */
          style: {
            overflow: 'hidden',
            position: 'absolute',
            right: '0',
            width: '40px',
            height: '100%',
            pointerEvents: 'none',
          },
        },
        Icon({
          ...props,
          size: 'large',
          name: 'keyboard_arrow_down',
          color: scssVariables.ColorBlack60,
        }),
      ),

    MenuProps: {
      slotProps: {
        list: {
          sx: {
            maxHeight: 'max(40vh, min(80vh, 350px))',
          },
        },
      },
    },
  },
  styleOverrides: {
    icon: {
      '@media screen and (prefers-reduced-motion: no-preference) ': {
        transition: 'transform 150ms ease-out',
      },
    },
    select: {
      minHeight: 'unset', // to prevent off-center alignment of select text due to our overwrites of input height in MuiInputBase
      overflow: 'hidden',
    },
  },
};
